import isSelectionEqual from './isSelectionEqual';

export default function smartSetSelections(
    event: {ctrlKey: boolean; metaKey: boolean},
    selections: SelectionState[],
    setSelections: SetState<SelectionState[]>,
    nextSelection: SelectionState
) {
    if (!event.ctrlKey && !event.metaKey) {
        setSelections([nextSelection]);
    } else if (selections.find((selection) => isSelectionEqual(selection, nextSelection))) {
        setSelections(
            selections.filter((selection) => !isSelectionEqual(selection, nextSelection))
        );
    } else {
        setSelections([...selections, nextSelection]);
    }
}
